import { useLayoutEffect } from "react";

const useDocumentTitle = (title) => {
  useLayoutEffect(() => {
    if (title) {
      document.title = title;
    } else {
      document.title = "Jiva's Originals";
    }
  }, [title]);
};

export default useDocumentTitle;
